<template>
    <CSidebar :show="store.showSidebar" fixed class="d-lg-none">
        <CHeaderNav class="flex-column align-items-start" style="width:100%">
            <CHeaderNavItem
                class="c-sidebar-nav-item"
                v-for="(menuItem, index) in (isAuthenticated ? menuItems: menuItemsNoAuthWMain)"
                :key="index"
            >
                <CHeaderNavLink
                    class="c-sidebar-nav-link"
                    :href="menuItem.href"
                    viewBox="0 0 24 24"
                >
                    <!--suppress HtmlUnknownTag -->
                    <CIcon
                        class="c-sidebar-nav-icon"
                        :name="menuItem.icon"
                    />
                    {{ menuItem.name }}
                </CHeaderNavLink>
            </CHeaderNavItem>
        </CHeaderNav>
        <CBadge v-if="!isSubscribed" color="success" class="mt-4 ml-4 mr-4 pt-2 pb-2" style="font-size:100%" :href="`/pricing`" size="md">
            Upgrade Account
        </CBadge>
    </CSidebar>
</template>

<script>
    import headerVars from "@/mixins/header-vars";
    import subscription from "@/mixins/subscription";

    export default {
        mixins: [headerVars, subscription]
    }
</script>

<style lang="scss" scoped>
    .c-sidebar .c-sidebar-nav-link {
        &:hover {
            background-color: #3b5998;
        }

        &.router-link-exact-active {
            background-color: #3b5998;
        }
    }
</style>
